import { Modal, Timeline } from "antd";

const AuditLogsModalView = ({ open, auditLogs = [], ticker = '', onClose }) => {
    return (
        <Modal
            title={`${ticker} Idea Log`}
            open={open}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <div style={{maxHeight: '50vh', overflowY: 'auto'}}>
                <Timeline
                    style={{paddingLeft: 12, paddingTop: 24, paddingBottom: 24}}
                    items={auditLogs.map((log, index) => {
                        let changes = {};
                        try {
                            changes = JSON.parse(log.changes || '{}');
                        } catch (error) {
                            console.error('Failed to parse changes:', error);
                        }
                        
                        return {
                            key: index,
                            dot: <div style={{width: 12, height: 12, backgroundColor: '#1890ff', borderRadius: '50%'}} />,
                            children: (
                                <div>
                                    <div style={{marginBottom: 8}}>
                                        <strong>{log.action}</strong>
                                        <span style={{marginLeft: 12, color: '#666', fontSize: 12}}>
                                            {log.operator}
                                        </span>
                                        <span style={{marginLeft: 12, color: '#999', fontSize: 12}}>
                                            {log.createdAt}
                                        </span>
                                    </div>
                                    {log.reason && (
                                        <div style={{marginBottom: 8, color: '#666', fontSize: 12}}>
                                            <strong>Reason:</strong> {log.reason}
                                        </div>
                                    )}
                                    {Object.keys(changes).length > 0 && (
                                        <div style={{marginBottom: 8}}>
                                            <strong style={{fontSize: 12}}>Changes:</strong>
                                            <div style={{marginTop: 4, paddingLeft: 12, fontSize: 12, color: '#666'}}>
                                                {Object.entries(changes).map(([key, value]) => (
                                                    <div key={key} style={{marginBottom: 4}}>
                                                        <span style={{color: '#999'}}>{key}:</span>
                                                        <span style={{marginLeft: 8}}>
                                                            {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        };
                    })}
                />
            </div>
        </Modal>
    );
};

export default AuditLogsModalView;

